import PostGrid from "@components/grid/PostGrid";
import { AttrProps } from "@customTypes/index";
import useResponsiveCmsSettings from "@hooks/useResponsiveCmsSettings";
import { CmsBreakPointsDefaults } from "@lib/constants";
import { Col, Layout, Row } from "antd";
import { useEffect, useState } from "react";

interface PostCollectionsProps {
    className?: string;
    attrs: AttrProps;
    results?: any[];
}

const defaultProps: PostCollectionsProps = {
    attrs: {
        breakpoints: {
            desktop: {
                total: CmsBreakPointsDefaults.DESKTOP.TOTAL
            },
            tablet: {
                total: CmsBreakPointsDefaults.TABLET.TOTAL
            },
            mobile: {
                total: CmsBreakPointsDefaults.MOBILE.TOTAL
            },
        }
    }
};

const PostCollections = ({ className, attrs, results }: PostCollectionsProps) => {
    const { total } = useResponsiveCmsSettings(attrs.breakpoints);
    const [items, setItems] = useState(results || []);

    useEffect(() => {
        if (total && Array.isArray(results)) {
            let updatedItems = [...results];
            updatedItems = updatedItems?.splice(0, total);
            setItems(total === results.length ? results : updatedItems);
        }
    }, [total, results])

    return (
        <Layout className={`covr-data-section ${className}`}>
            {attrs?.title &&
                <Row className="data-header">
                    <Col>
                        <h2>{attrs.title}</h2>
                    </Col>
                </Row>}
            <Row justify={`center`} className="data-body">
                <Col span={24}>
                    <PostGrid
                        data={items}
                        {...attrs}
                    />
                </Col>
            </Row>
            {attrs?.link?.url &&
                <Row className="data-footer" justify="end">
                    <Col>
                        <a target={attrs.link.target} className="view-all" href={attrs.link.url}>
                            {attrs.link.title}
                        </a>
                    </Col>
                </Row>}
        </Layout>
    );
};

PostCollections.defaultProps = defaultProps;

export default PostCollections;
